var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-shrink-0 items-center" },
    [
      _vm.showDecoration
        ? _c("StatusChip", { attrs: { status: _vm.chipStatus } })
        : _vm._e(),
      _vm._t("default", function () {
        return [
          _c("span", {
            staticClass: "text-sm text-gray-700 ml-1",
            class: _vm.textclass,
            domProps: { innerHTML: _vm._s(_vm.message) },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }